import { forwardRef } from 'react'

import SliderLib, { Settings } from 'react-slick'

import 'slick-carousel/slick/slick-theme.css'
import 'slick-carousel/slick/slick.css'

export const Slider = forwardRef<SliderLib, Settings>((props, ref) => {
  return (
    <SliderLib
      ref={ref}
      {...props}
    />
  )
})

Slider.displayName = 'Slider'

export type { Settings }
